import { render, staticRenderFns } from "./sidebar.vue?vue&type=template&id=b2dcbc8a&scoped=true&"
import script from "./sidebar.vue?vue&type=script&lang=js&"
export * from "./sidebar.vue?vue&type=script&lang=js&"
import style0 from "./sidebar.vue?vue&type=style&index=0&id=b2dcbc8a&lang=scss&scoped=scoped&"
import style1 from "./sidebar.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2dcbc8a",
  null
  
)

export default component.exports